import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { MODULO_FERROVIA } from '~/constants/modules';
import { t, number, can } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteModelosVeiculo,
  findModelosVeiculo,
  recordFiltering,
} from '~/store/modules/modeloveiculo/actions';

import Form from './form';

function ModelosVeiculoList() {
  const redux = useSelector((state) => state.modeloveiculo);

  const tipoModelo = useMemo(
    () => [
      { label: 'V', value: t('s.menu.cadastro.veiculo') },
      { label: 'L', value: t('s.menu.cadastro.veiculo.locomotiva') },
    ],
    []
  );

  const maxtag = useMemo(
    () => [
      { label: 0, value: 'Não Definido' },
      { label: 1, value: '1' },
      { label: 2, value: '2' },
      { label: 3, value: '3' },
      { label: 4, value: '4' },
      { label: 5, value: '5' },
      { label: 6, value: '6' },
      { label: 7, value: '7' },
      { label: 8, value: '8' },
      { label: 9, value: '9' },
      { label: 10, value: '10' },
    ],
    []
  );

  const header = useMemo(() => {
    const data = [
      {
        id: 'nomemodeloveiculo',
        label: t('s.cadastro.modeloveiculo.nomemodeloveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemarcaveiculo',
        label: t('s.cadastro.modeloveiculo.nomemarcaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'codigoauxiliarmodeloveiculo',
        label: t('s.cadastro.modeloveiculo.codigoauxiliarmodeloveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'codigofipemodeloveiculo',
        label: t('s.cadastro.modeloveiculo.codigofipemodeloveiculo'),
        align: 'right',
        filter: { type: 'text' },
      },
      {
        id: 'consumomediomodeloveiculo',
        label: t('s.cadastro.modeloveiculo.consumomediomodeloveiculo'),
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'maxtagveiculomodelo',
        label: t('s.cadastro.modeloveiculo.maxtagveiculomodelo'),
        align: 'right',
        // filter: { type: 'text' },
        formatted: (v) => maxtag.find((p) => p.label === v)?.value || '',
        filter: { type: 'select', options: maxtag },
      },
    ];

    if (can(MODULO_FERROVIA)) {
      data.splice(2, 0, {
        id: 'tipomodeloveiculo',
        label: t('s.cadastro.veiculo.tipoveiculo'),
        formatted: (value) =>
          tipoModelo.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: tipoModelo },
      });
    }

    return data;
  }, [maxtag]);

  const fieldlist = [
    'nomemodeloveiculo',
    'nomemarcaveiculo',
    'codigoauxiliarmodeloveiculo',
    'codigofipemodeloveiculo',
    'consumomediomodeloveiculo',
    'maxtagveiculomodelo',
  ];

  const substituirHeader = {
    nomemodeloveiculo: t('s.cadastro.modeloveiculo.nomemodeloveiculo'),
    nomemarcaveiculo: t('s.cadastro.modeloveiculo.nomemarcaveiculo'),
    codigoauxiliarmodeloveiculo: t(
      's.cadastro.modeloveiculo.codigoauxiliarmodeloveiculo'
    ),
    codigofipemodeloveiculo: t(
      's.cadastro.modeloveiculo.codigofipemodeloveiculo'
    ),
    consumomediomodeloveiculo: t(
      's.cadastro.modeloveiculo.consumomediomodeloveiculo'
    ),
    maxtagveiculomodelo: t('s.cadastro.modeloveiculo.maxtagveiculomodelo'),
  };

  if (can(MODULO_FERROVIA)) {
    fieldlist.push('tipomodeloveiculo');
    substituirHeader.tipomodeloveiculo = t('s.cadastro.veiculo.tipoveiculo');
  }

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findModelosVeiculo}
      remove={deleteModelosVeiculo}
      form={Form}
      keys="idmodeloveiculo"
      detach="nomemodeloveiculo"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'modelosveiculos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Locomotivas',
          substituirValores: {
            tipomodeloveiculo: {
              V: t('s.menu.cadastro.veiculo'),
              L: t('s.menu.cadastro.veiculo.locomotiva'),
            },
          },
        })
      }
    />
  );
}

export default ModelosVeiculoList;
